module.exports = __webpack_public_path__ + "img/error.4b475b78.png";